import { formatOutcome } from './badgeStyles';

// Transfer-specific failure/timeout reasons whose raw value doesn't read well
// when generically title-cased. Everything else falls through to the shared
// formatOutcome transform (snake_case -> Title Case).
const KNOWN_TRANSFER_REASONS: Record<string, string> = {
  all_agents_no_answer: 'No agent answered',
  max_caller_wait_exceeded: 'Caller wait time exceeded',
  stale_agent_status: 'Agent status timed out',
};

/** Format a live-transfer failure/timeout reason for display. */
export function formatTransferReason(reason: string | null | undefined): string {
  if (!reason) return '';
  const key = reason.trim().toLowerCase().replace(/[\s-]+/g, '_');
  return KNOWN_TRANSFER_REASONS[key] ?? formatOutcome(reason);
}
